import React from "react";
import { NumberInput, RadioGroup } from "@/components/tools/Inputs";
import { RISK_OPTIONS } from "@/lib/applyForm";

export const Step2 = ({ data, onChange, errors }) => {
  const set = (k) => (v) => onChange({ ...data, [k]: v });
  return (
    <div data-testid="apply-step-2" className="space-y-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <NumberInput
          label="Annual household income"
          value={data.income}
          onChange={set("income")}
          prefix="$"
          min={0}
          testId="apply-income"
          error={errors.income}
        />
        <NumberInput
          label="Existing retirement savings (optional)"
          value={data.retirement_savings}
          onChange={set("retirement_savings")}
          prefix="$"
          min={0}
          testId="apply-retirement-savings"
        />
        <NumberInput
          label="Existing life insurance coverage (optional)"
          value={data.existing_life_coverage}
          onChange={set("existing_life_coverage")}
          prefix="$"
          min={0}
          testId="apply-existing-coverage"
        />
        <NumberInput
          label="Total debt (optional)"
          value={data.debt}
          onChange={set("debt")}
          prefix="$"
          min={0}
          testId="apply-debt"
        />
        <NumberInput
          label="Monthly amount available to save (optional)"
          value={data.monthly_savings}
          onChange={set("monthly_savings")}
          prefix="$"
          min={0}
          testId="apply-monthly-savings"
        />
      </div>
      <RadioGroup
        label="Risk comfort"
        value={data.risk_comfort}
        onChange={set("risk_comfort")}
        options={RISK_OPTIONS}
        testId="apply-risk"
      />
    </div>
  );
};

export default Step2;
